export default {
  ADJUSTMENT_WARNING: (text) => ({
    type: 'warning',
    icon: 'error',
    text
  })
};